import React, { useState, useReducer, useEffect, useRef } from "react";

import { useHistory } from "react-router-dom";

// redux
import { useSelector, useDispatch } from "react-redux";

// Components imports
import LoginForm from "../../components/LoginForm/";

// Scss imports
import css from "./Login.module.scss";

interface LoginProps {}

const Login: React.FC<LoginProps> = () => {
  const loginStatus = useSelector((state: any) => state.login.loggedIn);
  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(true);

  const loginError = useSelector((state: any) => state.login.loginError);

  // Setting up state for input values, using use reducer hook
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: "",
      password: ""
    }
  );

  // Setting up form
  const [form, setForm] = useState({
    email: userInput.email,
    password: userInput.password
  });

  // Setting up error text state
  const [errorText, setErrorText] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: "",
      password: ""
    }
  );

  // Setting up variables
  let history = useHistory();

  useEffect(() => {
    // Set button status to enabled when all fields are valid
    if (
      userInput.email.match(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      ) != null &&
      userInput.password !== ""
    ) {
      setDisabledButton(false);
    }
  }, [userInput.password, userInput.email, errorText]);

  // Login button handler
  const onClickButtonHandler = (e: any) => {
    e.preventDefault();
    history.push("/basic-account");
  };

  // On input change set input name and value to text that user added
  const handleChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  // Set error on input
  const onInputHandler = (e, errorType, error, pattern) => {
    const newValue = e.target.value;
    // Validation with pattern
    if (newValue.match(pattern) == null) {
      setErrorText({
        [errorType]: error
      });
      setDisabledButton(true);
    }
    if (newValue.match(pattern) != null) {
      setErrorText({
        [errorType]: ""
      });
    }
  };

  return (
    <div className={css.container}>
      <div className={css.loginFormWrapper}>
        <h1>Улогуј се</h1>
        <p className={css.errorText}>{loginError}</p>
        <LoginForm
          onClickButtonHandler={onClickButtonHandler}
          handleChange={handleChange}
          email={userInput.email}
          password={userInput.password}
          errorEmailText={errorText.email}
          errorPasswordText={errorText.password}
          disabledButton={disabledButton}
          onInputPassword={(e) =>
            onInputHandler(e, "password", "Унеси шифру", "")
          }
          onInputEmail={(e) =>
            onInputHandler(
              e,
              "email",
              "Унеси исправну имејл адресу",
              "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
            )
          }
        />
      </div>
    </div>
  );
};

export default Login;
